import "config.css";
import "reset.css";
import "base.css";

import widgets from "@/widgets/index";
import templates from "@/templates/index";

import { pagegrowlerConfigFrontend } from "../pagegrowler.config";
import { FullApp, MinimalApp } from "@/shared/Application";

function Application({ Component, pageProps }) {
  /* Se importan los widgets desde la aplicacion padre hacia la libreria */
  pageProps.widgets = widgets;
  pageProps.templates = templates;
  pageProps.lila_url = process.env.NEXT_PUBLIC_LILAX_URL;
  pageProps.pagegrowler_backend_url =
    process.env.NEXT_PUBLIC_PAGEGROWLER_BACKEND_URL;
  pageProps.pagegrowler_frontend_api_url =
    process.env.NEXT_PUBLIC_PAGEGROWLER_FRONTEND_API;

  pageProps.matchConfig = pageProps.matchConfig || { query: {} };
  pageProps.externalConfig = pagegrowlerConfigFrontend;

  if (pageProps?.matchConfig?.template === "MinimalNews") {
    return <MinimalApp pageProps={pageProps} Component={Component} />;
  }
  return <FullApp pageProps={pageProps} Component={Component} />;
}
export default Application;
